/**
 * @generated SignedSource<<8d9e516bb1b6daeae8c8518a1a638e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateSelector_workspace$data = {
  readonly id: string;
  readonly templates: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TemplateSelectorTemplateItem_TodoWorkspaceTemplate">;
  }>;
  readonly " $fragmentType": "TemplateSelector_workspace";
};
export type TemplateSelector_workspace$key = {
  readonly " $data"?: TemplateSelector_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateSelector_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateSelector_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoWorkspaceTemplate",
      "kind": "LinkedField",
      "name": "templates",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplateSelectorTemplateItem_TodoWorkspaceTemplate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "eb9443c55e3876f8d3052bf7e80b30bc";

export default node;
